import { Flex, Loader as MantineLoader } from "@mantine/core";

export const Loader = () => {
  return (
    <Flex
      flex={1}
      direction="column"
      h="100%"
      w="100%"
      display="flex"
      align="center"
      justify="center"
    >
      <MantineLoader size="lg" />
    </Flex>
  );
};
